import {ActionList, ActionMenu, Button, Tooltip} from '@primer/react'
import {SyncIcon} from '@primer/octicons-react'
import {AUTO_REFRESH_OPTIONS, type AutoRefreshOptionId, getAutoRefreshOption} from './workflow-runs-auto-refresh'
import styles from './WorkflowRunsAutoRefreshMenu.module.css'

interface WorkflowRunsAutoRefreshMenuProps {
  value: AutoRefreshOptionId
  onChange: (value: AutoRefreshOptionId) => void
  onRefreshNow: () => void
  /** Shows the saved interval without the menu, for pages where auto-refresh doesn't run. */
  inactive?: boolean
}

export function WorkflowRunsAutoRefreshMenu({
  value,
  onChange,
  onRefreshNow,
  inactive = false,
}: WorkflowRunsAutoRefreshMenuProps) {
  const label = `Auto-refresh: ${getAutoRefreshOption(value).shortLabel}`

  if (inactive) {
    return (
      <Tooltip text="Auto-refresh is only available on the first page" direction="s">
        <Button variant="invisible" inactive aria-disabled="true" className={styles.Button}>
          {label}
        </Button>
      </Tooltip>
    )
  }

  return (
    <ActionMenu>
      <ActionMenu.Button variant="invisible" className={styles.Button}>
        {label}
      </ActionMenu.Button>
      <ActionMenu.Overlay width="small">
        <ActionList>
          <ActionList.Group selectionVariant="single">
            <ActionList.GroupHeading>Auto-refresh</ActionList.GroupHeading>
            {AUTO_REFRESH_OPTIONS.map(option => (
              <ActionList.Item
                key={option.id}
                role="menuitemradio"
                selected={option.id === value}
                onSelect={() => onChange(option.id)}
              >
                {option.label}
              </ActionList.Item>
            ))}
          </ActionList.Group>
          <ActionList.Divider />
          <ActionList.Item onSelect={onRefreshNow}>
            <ActionList.LeadingVisual>
              <SyncIcon />
            </ActionList.LeadingVisual>
            Refresh now
          </ActionList.Item>
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
